export default "__VITE_ASSET__5e0ce1c6__"